import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const SCALE_COLORS = [
  "#007AFF",
  "#D4FF00",
  "#34C759",
  "#FF9500",
  "#AF52DE",
  "#5AC8FA",
  "#FFD60A",
  "#FF3B30",
];

export default function CheckinTrendChart({ trendData, scaleKeys, labelFor }) {
  if (trendData.length < 2 || scaleKeys.length === 0) return null;

  return (
    <div
      className="bg-[#171717] border border-[#262626] rounded-lg p-5"
      data-testid="checkin-trend-chart"
    >
      <h4
        className="text-sm font-bold tracking-tight uppercase text-white mb-4"
        style={{ fontFamily: "Barlow Condensed, sans-serif" }}
      >
        ANDAMENTO METRICHE
      </h4>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={trendData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#262626" />
          <XAxis dataKey="week" stroke="#555" tick={{ fontSize: 11 }} />
          <YAxis stroke="#555" tick={{ fontSize: 11 }} domain={[0, "auto"]} />
          <Tooltip
            contentStyle={{
              backgroundColor: "#171717",
              border: "1px solid #262626",
              borderRadius: 6,
              fontSize: 12,
            }}
            labelStyle={{ color: "#999" }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {scaleKeys.map((k, i) => (
            <Line
              key={k}
              type="monotone"
              dataKey={k}
              name={labelFor(k)}
              stroke={SCALE_COLORS[i % SCALE_COLORS.length]}
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 5 }}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
